<template>
  <div class="dataCenter">
    <div class="header" :style="{top:!isFold?'225px':'93px'}">
      <div class="header_item" :class="active_tab_list==item.id?'active_header_item':''" v-for="item in tabList" :key="item.id" @click="changItemId(item)">{{ item.name }}</div>
    </div>
    <div class="content">
      <Analyze v-if="active_tab_list==1" />
      <Portrait v-if="active_tab_list==2" />
      <Review v-if="active_tab_list==3" />
    </div>

  </div>
</template>
    
    <script>
import Analyze from "../../components/training/Analyze.vue";
import Portrait from "../../components/training/Portrait.vue";
import Review from "../../components/training/Review.vue";
export default {
  data() {
    return {
      tabList: [
        {
          id: 1,
          name: "观众分析",
        },
        {
          id: 2,
          name: "观众画像",
        },
        {
          id: 3,
          name: "观众评论",
        },
      ],
      active_tab_list: 1,
    };
  },
  props:["isFold"],
  components: {
    Analyze,
    Portrait,
    Review,
  },
  mounted() {},

  methods: {
    changItemId(item) {
      this.active_tab_list = item.id;
      this.$emit("scrollTop")
    },
  },
};
</script>
    
<style scoped lang="scss">
.dataCenter {
  .header {
    width: 100%;
    position: fixed;
    display: flex;
    background: #f3f3f4;
    padding-bottom: 10px;
    top: 225px;
    z-index: 2500;
    .header_item {
      margin-right: 10px;
      color: #73757b;
      padding: 4px 8px;
      border-radius: 4px;
      cursor: pointer;
    }
    .active_header_item {
      background: #fff;
      color: #333;
    }
  }
  .content {
    padding-top: 30px;
  }
}
</style>
    